import React from 'react'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'

interface LoaderInterface {
    animation?: string,
    classname?: string,
    size?: string,
    variant?: string,
    style?: Object,
}

const Loader = ({animation, classname, size, variant, style}: LoaderInterface) => {
  return (
    <Col className="d-flex justify-content-center p-0 w-100">
      <Spinner
        animation={animation || 'border'}
        variant={variant || 'primary'}
        size={size || 'lg'}
        className={classname || 'm-3'}
        style={style}
      />
    </Col>
  )
}

export default Loader
